<ngx-datatable
  #table
  class="requestList bootstrap {{ scrollV ? 'fullscreen' : '' }}"
  [columnMode]="columnMode ? columnMode : ColumnMode.flex"
  [rows]="rows"
  [columns]="columns"
  [limit]="limit ? limit : 100000"
  [sorts]="sort"
  [rowHeight]="40"
  [headerHeight]="50"
  [scrollbarV]="scrollV ? scrollV : false"
  [scrollbarH]="true"
  [footerHeight]="showFooter ? '40' : '0'"
  (activate)="onActivate($event)"
  [messages]="messages"
  [loadingIndicator]="false"
  [selected]="selected"
  [selectionType]="selectedRow ? SelectionType.single : null"
  (select)="selectedRow ? onSelect($event) : null"
>
</ngx-datatable>

<ng-template #ProgressTemplate ngx-datatable-cell-template let-value="value">
  <div class="d-flex">
    <div class="outer-progress-bar">
      <div class="progress-bar {{ getColour(value) }}" [ngStyle]="{ width: value + '%' }"></div>
    </div>
    <p class="progress-label">{{ value }}%</p>
  </div>
</ng-template>

<ng-template #leiLinkTemplate ngx-datatable-cell-template let-value="value">
  <a class="lei-link" href="https://search.gleif.org/#/record/{{ value }}" target="_blank" [hidden]="!value">View</a>
</ng-template>

<ng-template #leiLinkWithRefTemplate ngx-datatable-cell-template let-value="value">
  <a class="lei-link" href="https://search.gleif.org/#/record/{{ value }}" target="_blank">{{ value }}</a>
</ng-template>

<ng-template #issuerNameLinkTemplate ngx-datatable-cell-template let-value="value">
  <button class="name-link" (click)="viewIssuer(value)">
    {{ value }}
  </button>
</ng-template>

<ng-template #distributorNameLinkTemplate ngx-datatable-cell-template let-value="value">
  <button class="name-link" (click)="viewDistributor(value)">
    {{ value }}
  </button>
</ng-template>

<ng-template #accessTagsLinkTemplate ngx-datatable-cell-template let-value="value">
  <button class="tag-link" (click)="editAccess(value)">Edit Access</button>
</ng-template>

<ng-template #userTagsLinkTemplate ngx-datatable-cell-template let-value="value">
  <button class="tag-link" (click)="addUserTag(value)">User Tags</button>
</ng-template>

<ng-template #connectionButtonTemplate ngx-datatable-cell-template let-value="value">
  <a role="button" class="btn-sm" (click)="viewRequest(value)" title="View request">
    <img class="ml-3" src="assets/view_request.svg" width="32" />
  </a>
</ng-template>

<ng-template #linkRequestButtonTemplate ngx-datatable-cell-template let-row="row" let-value="value">
  <a
    role="button"
    class="btn-sm"
    (click)="viewLinkedKydRequest(value)"
    title="View request"
    [hidden]="!['KYD', 'MDA', 'ADF'].includes(row.type)"
  >
    <img class="ml-3" src="assets/view_request.svg" width="32" />
  </a>
</ng-template>

<ng-template #distributorContactsButtonTemplate ngx-datatable-cell-template let-value="value">
  <button
    type="button"
    class="btn btn-primary btn-sm btn-outline-primary py-0"
    (click)="viewDistributorContacts(value)"
  >
    View Contact(s)
  </button>
</ng-template>

<ng-template #manageFilesButtonTemplate ngx-datatable-cell-template let-value="value">
  <button type="button" class="btn-sm p-0" (click)="manageFiles(value)" title="Manage files">
    <img class="ml-3" src="assets/files.svg" width="28" />
  </button>
</ng-template>

<ng-template #downloadButtonTemplate ngx-datatable-cell-template let-value="value" let-row="row" let-column="column">
  <button
    type="button"
    class="btn-sm p-0 ml-2 mr-2 downloadBtn"
    (click)="downloadFile(value, $event)"
    title="Download {{ row.fileName }}"
  >
    <div [id]="row.id" class="downloadIcon"></div>
  </button>
</ng-template>

<ng-template #issuerContactsButtonTemplate ngx-datatable-cell-template let-value="value">
  <button type="button" class="btn btn-primary btn-sm btn-outline-primary py-0" (click)="viewIssuerContacts(value)">
    View Contact(s)
  </button>
</ng-template>

<ng-template #viewConnectionButtonTemplate ngx-datatable-cell-template let-value="value">
  <button type="button" class="btn btn-primary btn-sm btn-outline-primary py-0 px-3" (click)="viewConnection(value)">
    View Connection(s)
  </button>
</ng-template>

<ng-template #viewIssuerRequestsButtonTemplate ngx-datatable-cell-template let-value="value">
  <button
    type="button"
    class="btn btn-primary btn-sm btn-outline-primary py-0 px-3"
    (click)="viewIssuerRequests(value)"
  >
    Details per Issuer
  </button>
</ng-template>

<ng-template #dateTemplate ngx-datatable-cell-template let-value="value">
  <ng-container [ngSwitch]="value">
    <span *ngSwitchCase="''">-</span>
    <span *ngSwitchCase="'-'">-</span>
    <span *ngSwitchDefault [title]="value">{{ value | date: 'dd/MM/yyyy':'GMT' }}</span>
  </ng-container>
</ng-template>

<ng-template #dateTimeTemplate ngx-datatable-cell-template let-value="value">
  <ng-container [ngSwitch]="value">
    <span *ngSwitchCase="''">-</span>
    <span *ngSwitchCase="'-'">-</span>
    <span *ngSwitchDefault [title]="value">{{ value | date: 'yyyy-MM-dd HH:mm':'GMT' }}</span>
  </ng-container>
</ng-template>

<ng-template #statusTemplate ngx-datatable-cell-template let-value="value">
  <span class="badge badge-maxwidth {{ getStatusColour(value) }} text-medium" [title]="value" *ngIf="value">{{
    value | titlecase
  }}</span>
</ng-template>

<ng-template #issuerStatusTemplate ngx-datatable-cell-template let-value="value" let-col="column">
  <ng-container [ngSwitch]="value">
    <span *ngSwitchCase="''">-</span>
    <span *ngSwitchDefault class="{{ col.cellClass }} pl-3">
      <!-- <span
        class="badge badge-pill badge-issuerStatus {{ getIssuerStatusColour(value) }} text-medium "
        [title]="value"
      ></span> -->
      <span class="statusText">{{ value }}</span></span
    >
  </ng-container>
</ng-template>

<ng-template #distNameAndConnectionStatus ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
  <ng-container [ngSwitch]="row.distributorName">
    <span *ngSwitchCase="''">-</span>
    <!-- <span *ngSwitchDefault class="star {{ row.connectionStatus }} " [title]="row.connectionStatus"></span> -->
    <span class="text-truncate pr-3">{{ row.distributorName }}</span>
  </ng-container>
</ng-template>

<ng-template #downloadTemplate ngx-datatable-cell-template let-value="value" let-row="row">
  <div class="spacer">
    &nbsp;&nbsp;&nbsp;
    <span
      class="actionSpan"
      *ngIf="
        (row.type === 'KYD' && ((!row.ddqVersionDate && !value) || (row.connectionStatus !== 'ACTIVE' && !value))) ||
        (row.type !== 'KYD' &&
          row.type !== 'Distribution Agreement' &&
          row.type !== 'MDA' &&
          row.type !== 'Annual Distributor Feedback' &&
          !value)
      "
    ></span>
    <a *ngIf="value" class="actionLink" title="View Reports"></a>
    <div
      *ngIf="
        row.ddqVersionDate &&
        row.connectionStatus == 'ACTIVE' &&
        (row.type == 'KYD' ||
          row.type === 'Distribution Agreement' ||
          row.type === 'MDA' ||
          row.type === 'Annual Distributor Feedback') &&
        value
      "
    >
      &nbsp;&nbsp;&nbsp;
    </div>
    <button
      *ngIf="
        (row.ddqVersionDate && row.connectionStatus == 'ACTIVE' && row.type == 'KYD') ||
        row.type === 'Distribution Agreement' ||
        row.type === 'MDA' ||
        (row.connectionStatus == 'ACTIVE' && row.type == 'Annual Distributor Feedback')
      "
      class="ddqLink"
      title="View DDQ"
      (click)="viewDDQ(row, $event)"
    ></button>
  </div>
</ng-template>

<ng-template #productActionButtonTemplate ngx-datatable-cell-template let-row="row" let-value="value">
  <div ngbDropdown class="d-inline-block" container="body" placement="left" display="dynamic">
    <fa-icon [icon]="faEllipsisV" class="pl-3 pr-2 icon-color fa-lg" id="dropdownMenu1" ngbDropdownToggle></fa-icon>
    <div class="dropdown-menu" aria-labelledby="dropdownMenu1" ngbDropdownMenu>
      <button class="dropdown-item" (click)="rowAction(row, 'view')">
        <img class="mr-2" src="assets/view_ddq.svg" /> View Detail
      </button>
      <button class="dropdown-item" (click)="rowAction(row, 'clone')">
        <img class="mr-2" src="assets/publish_to_distributor.svg" /> Clone Product
      </button>
      <button class="dropdown-item" (click)="rowAction(row, 'delete')">
        <img class="mr-2" src="assets/bin.svg" /> Delete Product
      </button>
    </div>
  </div>
</ng-template>

<ng-template #numberTemplate ngx-datatable-cell-template let-value="value">
  <ng-container [ngSwitch]="value">
    <span *ngSwitchCase="''">-</span>
    <span [title]="value">{{ value | number }}</span>
  </ng-container>
</ng-template>

<ng-template #titlecaseTemplate ngx-datatable-cell-template let-value="value" let-col="column">
  <ng-container [ngSwitch]="value">
    <span *ngSwitchCase="''">-</span>
    <span [title]="value">{{ value | titlecase }}</span>
  </ng-container>
</ng-template>

<ng-template #downloadDocTemplate ngx-datatable-cell-template let-value="value" let-col="column" let-row="row">
  <ng-container [ngSwitch]="value">
    <span *ngSwitchCase="''">-</span>
    <span
      *ngSwitchDefault
      title="Download {{ row.fileName }}"
      role="button"
      class="downloadIcon d-inline-block"
      (click)="download(value)"
    ></span>
  </ng-container>
</ng-template>
